import React from 'react';
import PropTypes from 'prop-types';

import RowItem from './RowItem';

const GenericDisplay = ({ tasks, title, openRightPanel, icon, suggestion }) => {
  return (
    <div className="col">
      <div style={{ fontSize: 16, fontWeight: 'bold' }}>
        <i className={icon} aria-hidden="true" style={{ marginRight: 10 }}></i>
        {title}
      </div>
      <table className="table table-striped" style={{ marginTop: 20 }}>
        <tbody>
          {
            tasks.map((t, k) => {
              return <RowItem key={k} task={t} openRightPanel={openRightPanel} />
            })
          }
        </tbody>
      </table>
      {/* <div style={{ fontSize: 12, fontWeight: 'bold' }}>
        Suggestion: {suggestion}
      </div> */}
    </div>
  )
}

GenericDisplay.propTypes = {
  tasks: PropTypes.array,
  title: PropTypes.string,
  openRightPanel: PropTypes.func,
  icon: PropTypes.string,
  suggestion: PropTypes.string,
};

export default GenericDisplay;




// WEBPACK FOOTER //
// ./src/views/Project/TaskDoctor/GenericDisplay.js